import { makeRequest } from "../http-common";

const SearchDataService = {
  search(term) {
    return makeRequest('get', `/search/${encodeURIComponent(term)}`);
  },

  filtered(q,type){
    return makeRequest('get', `/search/filtered/?q=${encodeURIComponent(q)}&type=${encodeURIComponent(type)}`);
  }
};

export default SearchDataService;